import React, { useEffect } from 'react'
import Pagetitle from './component/Pagetitle'
import MyAccountNav from './component/MyAccountNav'
import { useApiStore } from './hooks/ApiStoreContext';
import { useAuth } from './hooks/AuthProvider';
import { useForm } from 'react-hook-form';
import Swal from 'sweetalert2';

function MyAccountDetails() {
    const apiStore = useApiStore();
    const auth = useAuth();

    const {register, handleSubmit, formState: { errors }, reset, setValue, getValues, watch } = useForm({
        defaultValues: {
          userId: null,
          firstName: "",
          lastName: "",
          email: "",
          contact: "",
          currentPassword: "",
          newPassword: "",
          confirmPassword: "",
        },
      });

    useEffect(() => {
        console.log(auth);
        setValue("userId", auth.userId);
        fetchUserDetails();
    }, []);

    
    const fetchUserDetails = async () => {
        try {
            let userId=getValues("userId");
            let response = await apiStore.get(`/Accounts/GetUserDetails/${userId}`);
            //console.log(response);
            setValue("firstName",response.firstName);
            setValue("lastName",response.lastName);
            setValue("contact",response.contact);
            setValue("email",response.email);
        } catch (error) {
            console.error("There was an error fetching user details!", error);
        }
    };

    const handleAccount =async(data)=>{
        console.log(data);
        var response=await apiStore.post('/Accounts/UpdateUserDetails',data);
        console.log(response);
        if(response.status==400){
            await Swal.fire({ title: "Warning", text: response.detail, icon: "warning", confirmButtonText: "OK" });
        }
        else{            
            await Swal.fire({ title: "Success", text: "User details updated successfully!", icon: "success", confirmButtonText: "OK" });
        }

    }

    return (
        <>
            <Pagetitle title="My Account" />
            <section className="flat-spacing-11">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3">
                            <MyAccountNav activeLink="details" />
                        </div>
                        <div className="col-lg-9">
                            <div className="my-account-content account-edit">
                                <div className="">
                                    <form className="" id="form-password-change" onSubmit={handleSubmit(handleAccount)}>
                                        <div className="tf-field style-1 mb_15">
                                            <input className="tf-field-input tf-input" placeholder=" " type="text" id="firstName" name="first name" {...register("firstName")} />
                                            <label className="tf-field-label fw-4 text_black-2" htmlFor="firstName">Company name</label>
                                        </div>
                                        <div className="tf-field style-1 mb_15">
                                            <input className="tf-field-input tf-input" placeholder=" " type="text" id="lastName" name="last name" {...register("lastName")} />
                                            <label className="tf-field-label fw-4 text_black-2" htmlFor="lastName">Contact Person</label>
                                        </div>
                                        <div className="tf-field style-1 mb_15">
                                            <input className="tf-field-input tf-input" placeholder=" " type="text" id="contact" name="contact" {...register("contact")} />
                                            <label className="tf-field-label fw-4 text_black-2" htmlFor="contact">Contact number</label>
                                        </div>
                                        <div className="tf-field style-1 mb_15">
                                            <input className="tf-field-input tf-input" placeholder=" " type="email" id="email" name="email" disabled {...register("email")} />
                                            <label className="tf-field-label fw-4 text_black-2" htmlFor="email">Email</label>
                                        </div>
                                        <h6 className="mb_20">Password Change</h6>
                                        <div className="tf-field style-1 mb_30">
                                            <input className="tf-field-input tf-input" placeholder=" " type="password" id="currentPassword" name="currentPassword" {...register("currentPassword")} />
                                            <label className="tf-field-label fw-4 text_black-2" htmlFor="currentPassword">Current password</label>
                                        </div>
                                        <div className="tf-field style-1 mb_30">
                                            <input className="tf-field-input tf-input" placeholder=" " type="password" id="newPassword" name="newPassword" {...register("newPassword", { minLength: { value: 8, message: "Password should be minimum 8 characters in length." } })} />
                                            <label className="tf-field-label fw-4 text_black-2" htmlFor="newPassword">New password</label>
                                            <span className='text-xs text-danger'>{errors.newPassword?.message}</span>
                                        </div>
                                        <div className="tf-field style-1 mb_30">
                                            <input className="tf-field-input tf-input" placeholder=" " type="password" id="confirmPassword" name="confirmPassword" {...register("confirmPassword", {  validate: value => { if (watch('newPassword') != value) { return "Your passwords do no match"; } }, })} />
                                            <label className="tf-field-label fw-4 text_black-2" htmlFor="confirmPassword">Confirm password</label>
                                            <span className='text-xs text-danger'>{errors.confirmPassword?.message}</span>
                                        </div>
                                        <div className="mb_20">
                                            <button type="submit" className="tf-btn w-100 radius-3 btn-fill animate-hover-btn justify-content-center">Save Changes</button>
                                        </div>
                                    </form>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default MyAccountDetails